var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infooverlay",on:{"click":_vm.updateMapLabel}},[_c('transition',{attrs:{"name":"fade-fast","mode":"out-in"}},[_c('div',{key:_vm.text,staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }